/**
 * Strip CRM-only fields before using à la carte catalog items on portal/start.
 * Client-facing copy lives in `scope`, `deliverableRows`, `standardPricing`, `packages`, etc.
 */

const OMIT_KEYS = new Set([
  'internalOnly',
  'teamInput',
  'pricingStatus',
  'postedToTeam',
  'postedAt',
  'postedByUid',
  'teamSubmittedAt',
  'internalCost',
  'markupPercent',
  'markupAmount',
  'clientListPrice',
]);

/**
 * @param {Record<string, unknown>} item
 * @returns {Record<string, unknown>}
 */
export function sanitizeAlaCarteForPublic(item) {
  if (!item || typeof item !== 'object') return item;
  const out = { ...item };
  for (const k of OMIT_KEYS) {
    delete out[k];
  }
  return out;
}

/**
 * @param {Array<Record<string, unknown>>} items
 * @returns {Array<Record<string, unknown>>}
 */
export function sanitizeAlaCarteListForPublic(items) {
  if (!Array.isArray(items)) return [];
  return items.map(sanitizeAlaCarteForPublic);
}
